export default __webpack_public_path__ + "static/media/mobile2.829fcb72.png";